var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopcrmIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_9416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.33333V7.5H1.66667V7.08333C1.4375 7.08333 1.24139 7.00181 1.07833 6.83875C0.915 6.67542 0.833333 6.47917 0.833333 6.25V2.08333C0.833333 1.85417 0.915 1.65792 1.07833 1.49458C1.24139 1.33153 1.4375 1.25 1.66667 1.25H8.33333C8.5625 1.25 8.75875 1.33153 8.92208 1.49458C9.08514 1.65792 9.16667 1.85417 9.16667 2.08333V6.25C9.16667 6.47917 9.08514 6.67542 8.92208 6.83875C8.75875 7.00181 8.5625 7.08333 8.33333 7.08333V7.5H10V8.33333H0ZM1.66667 6.25H8.33333V2.08333H1.66667V6.25Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_9416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopcrmIcon);
export default __webpack_public_path__ + "static/media/laptopcrmIcon.2a4d6bc147b0d2e2c446d5b9121b62e8.svg";
export { ForwardRef as ReactComponent };